/* Iskra – product.js: warianty, galeria, pakiety, przyklejony przycisk. */
(() => {
  if (customElements.get('product-info')) return;
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = c => (T.formatMoney ? T.formatMoney(c) : String(c / 100));

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const json = $('[data-product-json]', this);
      if (!json || this._init) return;
      this._init = true;
      try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
      this.variants = this.data.variants || [];
      this.picker = $('variant-picker', this);
      if (!this.hasAttribute('data-no-url') && this.dataset.handle) this.remember(this.dataset.handle);
      const idInput = $('[data-variant-id]', this);
      this.current = this.variants.find(v => idInput && String(v.id) === idInput.value) || this.variants[0];
      this.addEventListener('change', e => { if (e.target.matches('[data-option]')) this.onOptionChange(); });
      if (this.picker) this.markAvailability(this.selected());
    }
    remember(handle) {
      try {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.preferencesProcessingAllowed === 'function' && !cp.preferencesProcessingAllowed()) return;
        const list = JSON.parse(localStorage.getItem('iskra-rv') || '[]').filter(h => h !== handle);
        list.unshift(handle);
        localStorage.setItem('iskra-rv', JSON.stringify(list.slice(0, 12)));
      } catch (e) { /* brak dostępu do pamięci */ }
    }
    get groups() { return this.picker ? $$('.variant-group', this.picker) : []; }
    selected() {
      return this.groups.map(g => {
        const sel = $('select[data-option]', g);
        if (sel) return sel.value;
        const r = $('input[data-option]:checked', g);
        return r ? r.value : null;
      });
    }
    onOptionChange() {
      const sel = this.selected();
      this.groups.forEach((g, i) => { const lbl = $('[data-selected-value]', g); if (lbl) lbl.textContent = sel[i] || ''; });
      this.markAvailability(sel);
      this.setVariant(this.variants.find(v => v.options.every((o, i) => o === sel[i])));
    }
    selectVariant(id) {
      const v = this.variants.find(x => x.id === Number(id));
      if (!v) return;
      this.groups.forEach((g, i) => {
        const sel = $('select[data-option]', g);
        if (sel) sel.value = v.options[i];
        else { const r = $$('input[data-option]', g).find(x => x.value === v.options[i]); if (r) r.checked = true; }
        const lbl = $('[data-selected-value]', g);
        if (lbl) lbl.textContent = v.options[i];
      });
      this.markAvailability(v.options);
      this.setVariant(v);
    }
    markAvailability(sel) {
      this.groups.forEach((g, i) => {
        const ok = val => this.variants.some(v => v.available && v.options[i] === val && v.options.every((o, j) => j >= i || o === sel[j]));
        $$('input[data-option]', g).forEach(inp => {
          const lbl = g.querySelector(`label[for="${inp.id}"]`);
          if (lbl) lbl.classList.toggle('is-unavailable', !ok(inp.value));
        });
        $$('select[data-option] option', g).forEach(o => { o.textContent = o.value + (ok(o.value) ? '' : ` – ${T.strings.soldOut}`); });
      });
    }
    setVariant(v) {
      this.current = v;
      const main = $('[data-atc]', this);
      const addLabel = (main && main.dataset.labelAdd) || T.strings.addToCart;
      const btns = $$('[data-atc], [data-sticky-btn]', this);
      if (!v) {
        btns.forEach(b => { b.disabled = true; const l = $('[data-atc-label]', b); if (l) l.textContent = T.strings.unavailable; });
        this.setAttribute('data-unavailable', '');
        return;
      }
      this.removeAttribute('data-unavailable');
      $$('[data-variant-id]', this).forEach(i => { i.value = v.id; });
      btns.forEach(b => { b.disabled = !v.available; const l = $('[data-atc-label]', b); if (l) l.textContent = v.available ? addLabel : T.strings.soldOut; });
      const sale = v.compare > v.price;
      $$('[data-price-wrap]', this).forEach(w => {
        if (w.closest('.upsell, .mini-card')) return;
        w.classList.toggle('is-sale', sale);
        const now = $('[data-price]', w);
        if (now) now.innerHTML = v.price_html;
        const was = $('[data-compare]', w);
        if (was) { was.hidden = !sale; was.innerHTML = sale ? v.compare_html : ''; }
        const save = $('[data-save]', w);
        if (save) {
          save.hidden = !sale;
          if (sale) save.textContent = save.dataset.style === 'amount'
            ? (T.strings.saveAmount || '[amount]').replace('[amount]', money(v.compare - v.price))
            : `-${Math.round(((v.compare - v.price) * 100) / v.compare)}%`;
        }
      });
      $$('[data-omnibus]', this).forEach(o => {
        o.hidden = !(sale && v.omni_html);
        const val = $('[data-omnibus-value]', o);
        if (val) val.innerHTML = v.omni_html || '';
      });
      $$('[data-sku]', this).forEach(s => { s.textContent = v.sku || ''; const p = s.closest('.psku'); if (p) p.classList.toggle('is-empty', !v.sku); });
      $$('stock-status', this).forEach(s => this.updateStock(s, v));
      const sticky = $('[data-sticky-variant]', this);
      if (sticky && sticky.value !== String(v.id)) sticky.value = String(v.id);
      if (!this.hasAttribute('data-no-url') && this.dataset.url) history.replaceState(history.state, '', `${this.dataset.url}?variant=${v.id}`);
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
    }
    updateStock(s, v) {
      const th = Number(s.dataset.threshold || 10);
      let state = 'in';
      if (!v.available) state = 'out';
      else if (v.tracked && v.inv > 0 && v.inv <= th) state = 'low';
      else if (!v.tracked && s.dataset.untracked !== 'true') state = 'hide';
      s.hidden = state === 'hide';
      s.classList.remove('is-in', 'is-low', 'is-out', 'is-hide');
      s.classList.add('is-' + state);
      const txt = $('[data-stock-text]', s);
      if (txt) txt.innerHTML = state === 'low' ? (s.dataset.low || '').replace('[count]', `<strong>${v.inv}</strong>`) : state === 'out' ? s.dataset.out : s.dataset.in;
      const fill = $('[data-stock-fill]', s);
      if (fill) fill.style.width = (state === 'low' ? Math.max(8, Math.round((v.inv * 60) / th)) : state === 'out' ? 0 : 88) + '%';
    }
  }
  customElements.define('product-info', ProductInfo);

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      if (!this.track || this._init) return;
      this._init = true;
      this.slides = $$('.gallery__slide', this.track);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $('[data-dots]', this);
      const prev = $('[data-prev]', this);
      const next = $('[data-next]', this);
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));
      this.thumbs.forEach(t => t.addEventListener('click', () => {
        const i = this.visible().findIndex(s => s.dataset.mediaId === t.dataset.mediaId);
        if (i > -1) this.go(i);
      }));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
      this.addEventListener('click', e => {
        const z = e.target.closest('[data-zoom-index]');
        if (z && this.dataset.zoom === 'true') this.zoom(Number(z.dataset.zoomIndex));
      });
      this.buildDots();
      const start = Number(this.dataset.start || 0);
      if (start) requestAnimationFrame(() => this.go(start, false));
      const info = this.closest('product-info');
      if (info) info.addEventListener('variant:change', e => this.onVariant(e.detail.variant));
      if ($('model-viewer', this) && window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: err => { if (!err) $$('model-viewer', this).forEach(mv => new window.Shopify.ModelViewerUI(mv)); } }]);
      }
    }
    isStacked() { return window.matchMedia('(min-width: 990px)').matches && (this.classList.contains('gallery--grid') || this.classList.contains('gallery--stack')); }
    visible() { return this.slides.filter(s => !s.hidden); }
    index() { return this.track.clientWidth ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0; }
    go(i, smooth = true) {
      const vis = this.visible();
      const slide = vis[i] || vis[0];
      if (!slide) return;
      const behavior = smooth && !reduce ? 'smooth' : 'auto';
      if (this.isStacked()) { slide.scrollIntoView({ behavior, block: 'nearest' }); return; }
      this.track.scrollTo({ left: vis.indexOf(slide) * this.track.clientWidth, behavior });
      this.mark(vis.indexOf(slide));
    }
    step(d) {
      const n = this.visible().length;
      if (!n) return;
      this.go((this.index() + d + n) % n);
    }
    sync() {
      const i = this.index();
      this.mark(i);
      this.visible().forEach((s, j) => { const v = $('video', s); if (j !== i && v && !v.paused) v.pause(); });
    }
    mark(i) {
      const vis = this.visible();
      const s = vis[i];
      if (!s) return;
      const cur = $('[data-current]', this);
      const total = $('[data-total]', this);
      if (cur) cur.textContent = i + 1;
      if (total) total.textContent = vis.length;
      let active = null;
      this.thumbs.forEach(t => { const on = t.dataset.mediaId === s.dataset.mediaId; t.classList.toggle('is-active', on); if (on) active = t; });
      if (active) {
        const c = active.parentElement;
        if (c.scrollHeight > c.clientHeight + 4) c.scrollTo({ top: active.offsetTop - c.clientHeight / 2 + active.clientHeight / 2, behavior: 'smooth' });
        else c.scrollTo({ left: active.offsetLeft - c.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
      if (this.dots) Array.from(this.dots.children).forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
    }
    buildDots() {
      if (!this.dots) return;
      const n = this.visible().length;
      this.dots.innerHTML = n > 1 ? Array.from({ length: n }, (_, i) => `<button type="button" class="gallery__dot" aria-label="${i + 1} / ${n}"></button>`).join('') : '';
      Array.from(this.dots.children).forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.mark(this.index());
    }
    onVariant(v) {
      if (!v) return;
      if (this.dataset.filter === 'true') this.filter(v);
      if (!v.media) return;
      const vis = this.visible();
      const i = vis.findIndex(s => s.dataset.mediaId === String(v.media));
      if (i < 0) return;
      if (this.isStacked() && this.classList.contains('gallery--grid')) {
        this.track.prepend(vis[i]);
        this.slides = $$('.gallery__slide', this.track);
      } else this.go(i);
    }
    filter(v) {
      const vals = v.options.map(o => String(o).toLowerCase().trim());
      const hit = el => el.dataset.alt && vals.indexOf(el.dataset.alt.trim()) > -1;
      const any = this.slides.some(hit);
      this.slides.forEach(s => { s.hidden = any ? !(hit(s) || !s.dataset.alt) : false; });
      this.thumbs.forEach(t => { t.hidden = any ? !(hit(t) || !t.dataset.alt) : false; });
      this.buildDots();
      this.track.scrollTo({ left: 0 });
    }
    zoom(index) {
      const lb = $('[data-lightbox]', this);
      if (!lb) return;
      lb.showModal();
      const target = $(`.lightbox__slide[data-index="${index}"]`, lb);
      if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }
  customElements.define('media-gallery', MediaGallery);

  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', () => this.mark());
      this.mark();
      const info = this.closest('product-info');
      if (info) info.addEventListener('variant:change', e => this.reprice(e.detail.variant));
    }
    mark() { $$('.break', this).forEach(b => { const i = $('input', b); b.classList.toggle('is-selected', !!(i && i.checked)); }); }
    reprice(v) {
      if (!v) return;
      const base = v.compare > v.price ? v.compare : v.price;
      $$('.break', this).forEach(b => {
        const inp = $('input', b);
        const q = Number(inp.dataset.qty);
        const d = Number(inp.dataset.discount);
        const total = (v.price - Math.floor((v.price * d) / 100)) * q;
        const was = base * q;
        const now = $('[data-break-now]', b);
        const w = $('[data-break-was]', b);
        if (now) now.textContent = money(total);
        if (w) { w.textContent = money(was); w.hidden = !(was > total); }
      });
    }
  }
  customElements.define('quantity-breaks', QuantityBreaks);

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form || !('IntersectionObserver' in window)) return;
      const anchor = $('[data-atc]', this.form) || this.form;
      this.hidden = false;
      this.io = new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('has-sticky-atc', show);
      });
      this.io.observe(anchor);
      const btn = $('[data-sticky-btn]', this);
      if (btn) btn.addEventListener('click', () => { if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.submit(); });
      const sel = $('[data-sticky-variant]', this);
      const info = this.closest('product-info');
      if (sel && info) sel.addEventListener('change', () => info.selectVariant(sel.value));
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); document.documentElement.classList.remove('has-sticky-atc'); }
  }
  customElements.define('sticky-atc', StickyAtc);
})();
